import moment from "moment";
import React, { useState } from "react";
import { List, ListInlineItem } from "react-feather";
import { Col, Input, Modal, ModalBody, Row } from "reactstrap";
import Title from "../../../../components/title";
import { ComonIcons } from "../../../../contents/commonIcons";
import { setShowExistingMemberModal } from "../../../../redux/actions/member/memberAction";
import { useDispatch, useSelector } from "react-redux";
import { createGymMember } from "../../../../redux/actions/api/apiAction";
import SpinnerComponent from "../../../../components/spinner/spinner";

export const NoteMemberDetails = ({  }) => {
  const dispatch=useDispatch()
  const { existingMember, existingMemberModal } = useSelector(
    (state) => state.member
  );
  const { gym} = useSelector(
    (state) => state.gym
  );
  const { RFIDCardId } = useSelector(
    (state) => state.membershipCard
  );
  console.log({existingMemberModal});
  const handleAddMemberToGym = () => {
    dispatch(
      createGymMember({
        member: existingMember.id,
        cardMembershipId: RFIDCardId ? RFIDCardId : null
      })
    );
  };
  const toggle = () => {
    dispatch(setShowExistingMemberModal(!existingMemberModal));
  };

  const { loading } = useSelector((state) => state.gym);

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );
  return (
    <>
      <Modal
        isOpen={existingMemberModal}
        toggle={toggle}
        centered={true}
        size="lg"
        className="large-pop adding-popup "
      >
        <ModalBody>
          <div className="bg-white mx-2">
            <div className="d-flex align-items-center border-bottom-1 pb-4">
              <div className="d-inline-flex ">
                <Title
                  title=" Member Details  "
                  subtitlestyle="ctf-tx-secondary"
                />
              </div>
              <div className="d-inline-flex ml-auto">
                <div className="close-icons pb-0">
                  <div className="text-right">
                    <span
                      className="svg-block"
                      onClick={() => {
                        toggle();
                      }}
                    >
                      {ComonIcons.closeBlack}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Row className="mb-4 mt-4">
              <Col md={3} className="ml-3">
                <span className="note-details member-info-bold">
                 First Name
                </span>
              </Col>
              <Col md={3}>
                <span className="note-details member-info-bold">Last Name</span>
              </Col>
              <Col md={3}>
                <span className="note-details member-info-bold">
                  
                  {existingMember.phone
                    ? 'phone'
                    : 'email'}
                </span>
              </Col>
            </Row>
            <Row className="mb-4 mt-4">
              <Col md={3} className="ml-3">
                <span className="note-details">
                  {existingMember?.firstName}
                </span>
              </Col>
              <Col md={3}>
                <span className="note-details">{existingMember?.lastName}</span>
              </Col>
              <Col md={3}>
                <span className="note-details">
                  {existingMember.phone
                    ? existingMember.phone
                    : existingMember.email}
                </span>
              </Col>
            </Row>
            <Row className="mx-0 w-100">
              <Col md={12} className="px-0">
                <div className="action-wrapper blk-padding-y d-flex justify-content-between minimize-btns">
                  <div className="action-inner-block d-flex justify-content-between w-100">
                    <React.Fragment>
                      <button
                        type="button"
                        className="btn btn-medium btn-transparent mr-4"
                        onClick={() => {
                          toggle();
                        }}
                      >
                        Cancel
                      </button>
                    </React.Fragment>
                    <button
                      className="btn btn-medium min-width-210"
                      type="button"
                      onClick={() => {
                        handleAddMemberToGym();
                      }}
                    >
                     {gym.type=="sportClub"?"Add Member to This Location": "Add member to Gym"}
                    </button>{" "}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default NoteMemberDetails;
